import { computed } from 'vue';
import get from 'lodash/get';

export const useHowItWorks = (props, emit) => {
    const selectedId = computed(() => get(props.modelValue, 'id'));
    const selectedImage = computed(() => get(props.modelValue, 'image'));
    const selectedTitle = computed(() => get(props.modelValue, 'title'));
    const selectedImageAlt = computed(() => get(props.modelValue, 'imageAlt'));

    const isActive = (id) => selectedId.value === id;

    const isLastItem = (id) => {
        const items = props.items || [];
        if (!items.length) return false;
        return get(items[items.length - 1], 'id') === id;
    };

    const handleClick = (id) => {
        const items = props.items || [];
        const found = items.find((item) => item.id === id);
        if (found) {
            emit('update:modelValue', found);
        }
    };

    return {
        selectedId,
        selectedImage,
        selectedTitle,
        selectedImageAlt,
        isActive,
        isLastItem,
        handleClick,
    };
};

export default useHowItWorks;
